import React from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button } from 'ui/atoms';
import MainFont from 'ui/typography/mainFont';

import routes from '../../routing/routes';

import {
  ButtonWrapper,
  PasswordSuccessHeader,
  PasswordSuccessText,
  PasswordSuccessWrapper,
  SuccessIconWrapper
} from './style';

const PasswordSuccessPage = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const onLoginClick = () => {
    history.push(routes.signin.path);
  };
  return (
    <PasswordSuccessWrapper>
      <PasswordSuccessHeader>
        <MainFont configuration={{ fontSize: 24 }} type="3">
          {t('password_created')}
        </MainFont>
      </PasswordSuccessHeader>
      <SuccessIconWrapper className="icon-success_icon" />
      <PasswordSuccessText>
        <MainFont configuration={{ fontSize: 14 }} type="3">
          {t('password_created_text')}
        </MainFont>
      </PasswordSuccessText>
      <ButtonWrapper onPswChangeSuccess>
        <Button variant="login" onClick={onLoginClick}>
          {t('login')}
        </Button>
      </ButtonWrapper>
    </PasswordSuccessWrapper>
  );
};

export default PasswordSuccessPage;
